import { useState, useEffect } from "react"
import { TeamMember } from "./team-carousel/TeamMember"
import "./teamCarousel.css"

export function TeamCarousel() {
    const [activeIndex, setActiveIndex] = useState(0)
    const dots = [0, 1, 2, 3, 4]
    var x

    useEffect(() => {
        x = setTimeout(() => {
            if (activeIndex === dots.length - 1) {
                setActiveIndex(0)
            } else {
                setActiveIndex(activeIndex + 1)
            }
        }, 2000)
    }, [activeIndex])

    function slideTo(i) {
        clearTimeout(x)
        setActiveIndex(i)
    }

    return (
        <div className="carousel overflow-hidden position-relative mx-auto">
            <div className="carousel-container position-relative d-flex gap-4" style={{
                left: (-34 * activeIndex) + "%",
                transition: "0.3s"
            }}>
                <TeamMember
                    image="/images/cruise.jpg"
                    name="Tom Cruise"
                    role="Founder & Chairman"
                />
                <TeamMember
                    image="/images/watson.jpg"
                    name="Emma Watson"
                    role="Managing Director"
                />
                <TeamMember
                    image="/images/smith.jpg"
                    name="Will Smith"
                    role="Product Designer"
                />
                <TeamMember
                    image="/images/cruise.jpg"
                    name="Tom Cruise"
                    role="Founder & Chairman"
                />
                <TeamMember
                    image="/images/watson.jpg"
                    name="Emma Watson"
                    role="Managing Director"
                />
                <TeamMember
                    image="/images/smith.jpg"
                    name="Will Smith"
                    role="Product Designer"
                />
                <TeamMember
                    image="/images/cruise.jpg"
                    name="Tom Cruise"
                    role="Founder & Chairman"
                />
            </div>

            <div className="indicators-section d-flex cntr w-100 mt-5">
                {
                    dots.map(e => (
                        <div
                            key={e}
                            onClick={() => slideTo(e)}
                            className={"carousel-indicator " + (activeIndex === e && "active")}>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}